import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { API_URL } from '../api/client';

export const namespaces = [
  'common',
  'auth',
  'dashboard',
  'admin',
  'errors',
] as const;

export type Namespace = (typeof namespaces)[number];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    ns: [...namespaces],
    defaultNS: 'common',

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    backend: {
      loadPath: `${API_URL}/translations/{{lng}}`,
      crossDomain: true,
      parse: (data: string, _url: string, _lng: string, ns: string) => {
        try {
          const parsed = JSON.parse(data);
          return parsed[ns] || {};
        } catch {
          return {};
        }
      },
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
